/** The studio's real social profiles. Add Behance, X etc. here once they exist. */
export const SOCIALS = [
  { name: 'Instagram', href: 'https://www.instagram.com/natwicstudio' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/natwic/' },
];
